import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleError } from '@/api/ex'

/**
 * ファイル取得API
 * @param  {} params={}
 */
export const fetchFile = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const options = {
    ...NEW_API_CONFIG,
    responseType: 'arraybuffer'
  }

  const newAxios = axios.create(options)
  return newAxios.post('/CM/003', r).catch(handleError)
}

/**
 * ファイル取得APIのURLを取得する
 * 【用途】
 *  QA詳細画面でPDFを表示する
 *  書式DL画面で書式のリンクを生成する
 * @param {numeric} fileId ファイルID
 * @param {boolean} isDownload ダウンロードフラグ(Content-Disposition: attach を付与する場合はtrue)
 */
export const getFetchFileAPIURL = (fileId, isDownload = false) => {
  const token = store.state.auth.token
  const download = isDownload ? 1 : 0
  const organizationId = store.state.profile.organization_id
  
  return `${NEW_API_CONFIG.baseURL}/CM/003?file_id=${fileId}&token=${encodeURIComponent(token)}&download=${encodeURIComponent(download)}&organization_id=${organizationId}`
}

/**
 * 利用者設定取得API
 * @param  {} params={}
 */
export const fetchUserSetting = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/CM/004', r).catch(handleError)
}

/**
 * 利用者設定更新API
 * @param  {} params={}
 */
export const updateUserSetting = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId,
    setting_value: typeof params.setting_value === 'object'
      ? JSON.stringify(params.setting_value)
      : params.setting_value
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/CM/005', r).catch(handleError)
}

/**
 * マスター取得API
 * @param  {} params={}
 */
export const fetchMaster = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/CM/007', r).catch(handleError)
}

/**
 * マスター取得API
 * @param  {} params={}
 */
export const fetchKnowledfeAuthFile = (filePath) => {
  // const defaults = {
  //   _path: 'CM/009',
  //   token: store.state.auth.token
  // }

  // const r = { ...defaults, ...params }

  return NEW_API_CONFIG.baseURL + '/CM/009?_path=' + encodeURIComponent('CM/009') + '&file_path=' + filePath + '&token=' + encodeURIComponent(store.state.auth.token) + '&organization_id=' + encodeURIComponent(store.state.profile.organization_id)


  // return axios.post(API_RELAY_PATH, r)
}

